<template>
  <li class="dropdown">
    <a class="dropdown-toggle label-menu-corner" href="#" data-toggle="dropdown" style="" aria-expanded="false" @click="readNotifications">
      <i class="pe-7s-speaker">
      </i>
      <span v-if="unreadNotifications !== 0" class="label label-danger">{{unreadNotifications}}</span>
    </a>

    <ul class="dropdown-menu hdropdown notification animated bounceIn">
      <li v-for="(notification, key) in notifications" :key="key" >
        <table style="width: 100%">
          <tbody>
          <tr >
            <td width="150px" class="text-center">
              <span v-if="notification.read_at === null" class="label label-success">NEW</span>
              <span v-else >
                <small class="text-success">{{notification.created_at | moment('LL')}}</small>
              </span>
            </td>
            <td style="padding-left: 10px">
              <a v-if="notification.link !== null && notification.link.indexOf('http') !== false" :href="notification.link" target="_blank">
                {{notification.title}}
              </a>
              <router-link v-else :to="{ path: (notification.link === null ? '#' : notification.link)}">
                {{notification.title}}
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </li>
      <li class="summary"><router-link :to="{name: 'Notifications'}">See all notifications</router-link></li>
    </ul>
  </li>

</template>

<style scoped>
  .dropdown-menu.notification {
    min-width: 400px;
    max-width: 500px;
  }
  .dropdown-menu.hdropdown.notification li .label {
     margin-right: 0;
  }
</style>

<script>

import axios from 'axios'

export default {
  components: {},
  props: [],
  name: 'NotificationsNavigation',
  data () {
    return {
      notifications: [],
      unreadNotifications: 0
    }
  },
  watch: {
    notifications: function () {
      this.unreadNotifications = 0
      this.notifications.forEach((notification) => {
        if (notification.read_at === null) {
          ++this.unreadNotifications
        }
      })
    },
    '$route' (to, from) {
      this.getResources()
    }
  },
  methods: {
    getResources: function () {
      axios.get('notifications?limit=5').then((response) => {
        this.notifications = response.data
      })
    },
    readNotifications: function () {
      axios.patch('notifications/read').then((response) => {
        this.unreadNotifications = 0
      })
    }
  },
  beforeMount() {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/notification/NotificationsNavigation.vue